import { stylesToCSS } from './css'

/**
 * Create the style formatting accepted by Chrome DevTools.
 */
export function makeStyledText(text: string, styles: Record<string, string>) {
  return [`%c${text}`, stylesToCSS(styles)]
}
